import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const WORDS = [
  "Excavation", "Foundations", "Drainage", "Soakaways",
  "Concrete", "Site Clearance", "CCTV Surveys", "Earthworks",
];

export const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-line bg-coal-800 py-6 md:py-8" aria-hidden="true">
    <Marquee speed={28} gradient={false} pauseOnHover={false}>
      {WORDS.map((word, i) => (
        <span key={word} className="flex items-center">
          <span
            className={`px-6 font-display text-4xl uppercase leading-none md:px-10 md:text-6xl ${
              i % 2 === 0 ? "text-white/90" : "stroke-text"
            }`}
          >
            {word}
          </span>
          <Asterisk size={26} className="shrink-0 text-ember" />
        </span>
      ))}
    </Marquee>
  </div>
);
